import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { SCREENS } from '../../../constants/screens';
import { appStore } from 'src/mobx/appStore';
import { observer } from 'mobx-react';

export interface IRouterProps extends RouteComponentProps<any> {}

@observer
class ScrollToTop extends React.Component<IRouterProps> {
  approveToTop = [
    SCREENS.ABOUT(),
    SCREENS.FAQ(),
    SCREENS.TERMS(),
    SCREENS.PRIVACY(),
    SCREENS.CONTACTS(),
    SCREENS.FRANCHISE(),
  ];
  componentDidUpdate() {
    if (appStore?.settings?.is_franchise_text_enabled) {
      this.approveToTop.push(SCREENS.FRANCHISE());
    }
    if (this.approveToTop.includes(this.props.location.pathname)) window.scrollTo(0, 0);
  }

  render() {
    return React.Fragment;
  }
}

export default withRouter(ScrollToTop);
